import { render } from "./typography.vue?vue&type=template&id=2400bbae"
import script from "./typography.vue?vue&type=script&lang=js"
export * from "./typography.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__